// React bootstrap table next =>
// DOCS: https://react-bootstrap-table.github.io/react-bootstrap-table2/docs/
// STORYBOOK: https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import React, { useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import * as uiHelpers from "../HistoryUIHelpers";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
} from "../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../_metronic/_partials/controls";
import { useHistoryUIContext } from "../HistoryUIContext";
import { EXPECTED_DELIVERY_DATE_CAPITAL } from "../../../utils/const";

export function HistoryTable({
  isLoading,
  transactionList,
  filterValues,
  transactionListTotalCount,
  currentPage,
  setCurrentPage,
}) {
  // History UI Context
  const historyUIContext = useHistoryUIContext();
  const historyUIProps = useMemo(() => {
    return {
      ids: historyUIContext.ids,
      setIds: historyUIContext.setIds,
      queryParams: historyUIContext.queryParams,
      setQueryParams: historyUIContext.setQueryParams,
      openReceiptDialog: historyUIContext.openReceiptDialog,
    };
  }, [historyUIContext]);

  // Table columns
  const columns = [
    {
      dataField: "id",
      text: "TRANSACTION ID",
      // sort: true,
      // sortCaret: sortCaret,
      style: {
        minWidth: "110px",
      },
      formatter: columnFormatters.TransactionValueFormatter,
    },
    {
      dataField: "sendername",
      text: "SENDER NAME",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "150px",
      },
      formatter: columnFormatters.ReciptNameColumnFormatter,
    },
    {
      dataField: "receivername",
      text: "RECEIVER NAME",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "150px",
      },
      formatter: columnFormatters.ReceiverNameColumnFormatter,
    },
    {
      dataField: "amount",
      text: "AMOUNTS",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "110px",
      },
      formatter: columnFormatters.AmountColumnFormatter,
    },
    {
      dataField: "commission",
      text: "COMMISSION",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "110px",
      },
      formatter: columnFormatters.CommissionColumnFormatter,
    },
    {
      dataField: "createdAt",
      text: "Date",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "110px",
      },
      formatter: columnFormatters.DateTimeColumnFormatter,
    },
    // {
    //   dataField: "expecteddeliverydate",
    //   text: EXPECTED_DELIVERY_DATE_CAPITAL,
    //   sort: true,
    //   sortCaret: sortCaret,
    //   style: {
    //     minWidth: "110px",
    //   },
    //   formatter: columnFormatters.ExpectedDeliveryDateColumnFormatter,
    // },
    {
      dataField: "confirmation_id",
      text: "CONFIRMATION ID",
      // sort: true,
      // sortCaret: sortCaret,
      style: {
        minWidth: "110px",
      },
      formatter: columnFormatters.ConfirmationIDFormatter,
    },
    {
      dataField: "confirmation_date",
      text: "CONFIRMATION DATE",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "110px",
      },
      formatter: columnFormatters.ConfirmationDateFormatter,
    },
    {
      dataField: "sc_transactionId",
      text: "SC-TRANSACTION ID #",
      // sort: true,
      // sortCaret: sortCaret,
      formatter: columnFormatters.SCTransactionFormatter,

      style: {
        minWidth: "110px",
      },
    },
    {
      dataField: "sc_type",
      text: "SC-TRANSACTION TYPE",
      formatter: columnFormatters.SCTransactionTypeFormatter,
      style: {
        minWidth: "110px",
      },
    },
    {
      dataField: "deposite_type",
      text: "DEPOSIT TYPE	",
      formatter: columnFormatters.DepositeTypeColumnFormatter,
      style: {
        minWidth: "110px",
      },
    },
    {
      dataField: "transaction_status",
      text: "STATUS	",
      formatter: columnFormatters.StatusTypeFormatter,
      style: {
        minWidth: "200px",
      },
    },
    {
      dataField: "ip_country",
      text: "IP	",
      formatter: columnFormatters.IPFormatter,
      style: {
        minWidth: "110px",
      },
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openReceiptDialog: historyUIProps.openReceiptDialog,
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "80px",
      },
    },
  ];
  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: transactionListTotalCount ? transactionListTotalCount : 0,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: historyUIProps.queryParams.pageSize,
    page: currentPage,
    onPageChange: (page) => {
      if (page === 0) return;
      setCurrentPage(page);
    },
  };
  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination isLoading={isLoading} paginationProps={paginationProps}>
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-head-bg table-borderless table-vertical-center history-table"
                bootstrap4
                bordered={false}
                remote
                keyField="id"
                data={transactionList ? transactionList : []}
                columns={columns}
                // defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  historyUIProps.setQueryParams
                )}
                {...paginationTableProps}
              >
                <PleaseWaitMessage isLoading={isLoading} />
              </BootstrapTable>
              <NoRecordsFoundMessage
                entities={transactionList}
                errorMessage={"No transactions found!"}
              />
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
}
